import { ApiClient } from "lib/utils/client/apiClient"

export const builderWidgetsDetails = async () => {
   return ApiClient('/builder-user/count',
      {
         method: 'GET',
      }
   )
};

export const builderslisting = async (data :{status:string,search?:string,page:number,limit:number}) => {
   return ApiClient('/builder-user/all-builder',
      {
         method: 'POST',
         body: JSON.stringify(data)
      }
   )
};

export const builderDetailById = async (id: string) => {
   return ApiClient(`/builder-user/builder/${id}`,
      {
         method: 'GET',
      }
   )
};

export const updateBuilderDetails= async(data:{id:string, company_name?:string, email?:string, phone_no?:string, Account_status?:string}) => {
   return ApiClient(`/builder-user/update-builder`,
      {
         method: 'PATCH',
         body: JSON.stringify(data)
      }
   )
};

export const builderImageUpload = async (id: string, data: FormData) => {
   return ApiClient(`/builder-user/upload/${id}`,
      {
         method: 'PATCH',
         body: data
      }
   )
};